// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3a4gU","search":"Settings_search__2lux3","filter":"Settings_filter__1hFV1"};